import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ['Mujeres que sienten que están "perdiendo el juicio" debido a las manipulaciones de su pareja.', 'Madres que necesitan sanar para no heredar este ciclo de trauma a sus hijos.', 'Profesionales exitosas que no entienden cómo cayeron en una relación tan destructiva.', 'Sobrevivientes que ya se fueron físicamente, pero siguen atrapadas mentalmente en el pasado.'];
  const notFor = ['Personas que buscan "venganza" o tácticas para intentar cambiar o manipular al narcisista.', 'Quienes no están dispuestas a cortar el suministro de información y contacto con el abusador.', 'Casos que requieren intervención psiquiátrica o legal urgente sin acompañamiento profesional adicional.'];
  return <section className="py-24 px-4 bg-dark-900" data-id="element-178">
      <div className="max-w-6xl mx-auto" data-id="element-179">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20" data-id="element-180">
          {/* Who is for */}
          <FadeIn data-id="element-181">
            <h2 className="text-2xl md:text-3xl mb-8 text-gold" data-id="element-182">
              Para quién es esto
            </h2>
            <div className="space-y-6" data-id="element-183">
              {isFor.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-184">
                  <CheckCircle2 className="w-6 h-6 text-gold shrink-0 mt-1" data-id="element-185" />
                  <p className="text-offwhite/80 font-light text-lg leading-relaxed" data-id="element-186">
                    {item}
                  </p>
                </div>)}
            </div>
          </FadeIn>

          {/* Who is NOT for */}
          <FadeIn delay={0.2} data-id="element-187">
            <h2 className="text-2xl md:text-3xl mb-8 text-offwhite/50" data-id="element-188">
              Para quién NO es
            </h2>
            <div className="space-y-6" data-id="element-189">
              {notFor.map((item, index) => <div key={index} className="flex items-start gap-4 opacity-70" data-id="element-190">
                  <XCircle className="w-6 h-6 text-red-500/50 shrink-0 mt-1" data-id="element-191" />
                  <p className="text-offwhite/60 font-light text-lg leading-relaxed" data-id="element-192">
                    {item}
                  </p>
                </div>)}
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}